import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * FE-282 Pass 12: redirect /invoices/ap/new → /invoices/new?kind=ap.
 * См. /invoices/ar/new для обоснования.
 */
export const Route = createFileRoute('/_auth/invoices/ap/new')({
  beforeLoad: () => {
    throw redirect({ to: '/invoices/new', search: { kind: 'ap' } as never });
  },
});
